export class WhisperService {
  private model: any = null;
  private modelLoaded: boolean = false;
  private modelName: string;
  private loadingPromise: Promise<void> | null = null;

  constructor() {
    this.modelName = import.meta.env.VITE_WHISPER_MODEL || 'whisper-tiny';
  }

  async initialize(): Promise<void> {
    if (this.modelLoaded) {
      return;
    }

    if (!this.loadingPromise) {
      this.loadingPromise = this.loadModel();
    }

    await this.loadingPromise;
  }

  private async loadModel(): Promise<void> {
    try {
      // Check if Transformers.js is available
      if (typeof window === 'undefined' || !(window as any).pipeline) {
        throw new Error('Transformers.js library not loaded');
      }

      const { pipeline } = await (window as any).pipeline;

      this.model = await pipeline('automatic-speech-recognition', 'Xenova/' + this.modelName, {
        progress_callback: (progress: any) => {
          console.log('Whisper loading progress:', progress);
        }
      });

      this.modelLoaded = true;
      console.log(`Whisper model ${this.modelName} loaded successfully`);
    } catch (error) {
      console.error('Failed to load Whisper model:', error);
      throw error;
    }
  }

  async transcribe(audioBlob: Blob): Promise<string> {
    if (!this.modelLoaded) {
      await this.initialize();
    }

    try {
      // Convert blob to audio array
      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      const arrayBuffer = await audioBlob.arrayBuffer();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
      const audioData = audioBuffer.getChannelData(0);

      // Run transcription
      const result = await this.model(audioData, {
        chunk_length_s: 30,
        stride_length_s: 5
      });

      return result.text || '';
    } catch (error) {
      console.error('Whisper transcription error:', error);
      throw error;
    }
  }

  async transcribeFromURL(audioUrl: string): Promise<string> {
    const response = await fetch(audioUrl);
    const blob = await response.blob();
    return this.transcribe(blob);
  }

  isModelLoaded(): boolean {
    return this.modelLoaded;
  }

  getModelName(): string {
    return this.modelName;
  }

  async unload(): Promise<void> {
    if (this.model) {
      this.model = null;
      this.modelLoaded = false;
    }
  }
}